<template>
    <div class="app-shot-drawer" :class="{visible:visible}" @click="handleClick">
        <app-icon class="app-shot-drawer__close-button" value="icon-close"/>
        <div class="app-shot-drawer__content" @click.stop="handleContentClick">
            <slot/>
        </div>
    </div>
</template>

<script>
    import AppIcon from '../AppIcon'
    
    export default {
        name: "AppDrawer",
        components: {
            AppIcon
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            visible(val) {
                this.switchScroll(val)
            }
        },
        methods: {
            handleClick() {
                this.$emit('click')
            },
            handleContentClick() {
            },
            switchScroll(flag) {
                const bodyElement = document.body
                flag ? bodyElement.classList.add('no-scroll') :
                    bodyElement.classList.remove('no-scroll')
            }
        },
        beforeDestroy() {
            this.switchScroll(false)
        }
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";
    @import "@assets/styles/mixins.scss";
    
    .app-shot-drawer {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1996;
        background: rgba(0, 0, 0, .8);
        width: 0;
        height: 0;
        opacity: 0;
        transition: opacity 0.2s ease;
        
        &.visible {
            width: 100%;
            height: 100%;
            opacity: 1;
            pointer-events: auto;
            
            .app-shot-drawer__content {
                opacity: 1;
                transform: translateY(0) scale(1);
            }
        }
        
        &__content {
            height: calc(100vh - #{($fontSizeMD+$paddingBase*4)});
            margin-top: $fontSizeMD+$paddingBase*4;
            background-color: $backgroundColor;
            background-color: var(--backgroundColor);
            border-radius: $radius $radius 0 0;
            opacity: 0;
            overflow: auto;
            transform: translateY(20%) scale(0.98);
            transition-delay: .2s;
            transition: opacity 0.2s ease, transform 0.3s ease, -webkit-transform 0.3s ease;
        }
        
        &__close-button {
            position: absolute;
            right: 0;
            top: $paddingBase;
            font-size: $fontSizeMD;
            color: $darkSecondaryTextColor;
            color: var(--drawerCloseIconColor);
            padding: $paddingBase;
            cursor: pointer;
            @include transition-colors;
            
            &:hover {
                color: $darkTextHighLightColor;
                color: var(--drawerCloseIconHighLightColor);
            }
        }
        
    }
</style>